import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { SortByModule } from '../../../pipes/sort-by/sort-by.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { BannerModule } from '../../components/banner/banner.module';
import { CardCategoryModule } from '../../components/card-category/card-category.module';
import { CardEventModule } from '../../components/card-event/card-event.module';
import { SwiperCitiesModule } from '../../components/swiper-cities/swiper-cities.module';
import { FilterCategoryPipe } from './filter-category.pipe';
import { FilterMonthPipe } from './filter-month.pipe';
import { FilterTeamPipe } from './filter-team.pipe';

@NgModule({
  declarations: [
    HomeComponent,
    FilterCategoryPipe,
    FilterMonthPipe,
    FilterTeamPipe
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SwiperModule,
    SortByModule,
    BannerModule,
    CardCategoryModule,
    CardEventModule,
    SwiperCitiesModule,
  ]
})
export class HomeModule { }
